// Custom select
$(document).ready(function() {
  var isSelect = '.tv-js-contactForm-select';
  var isRadio = '.tv-js-store-contact';
  $('#contact_date').addClass('hide');
  $('.tv-space-top').addClass('hide');
  $(document).on('change', $(isSelect), function() {
    customSelect();
  });

  $(document).on('change', isRadio, function() {
    customRadio($(this)[0]);
  });

  customSelect();

  $(isRadio).each(function() {
    customRadio($(this)[0]);
  });
});

function customSelect() {
  var selectContainer = $('.tv-js-contactForm-select').closest('.tv-contactForm-selectContainer'),
      option_selected = $('.tv-js-contactForm-select').find('option:selected'),
      parent =  $('.tv-js-contactForm-select').closest('form'),
      personal = $('.tv-js-personal');

  if(option_selected.length && option_selected.val() != '') {
    $(selectContainer).find('.selectText').html(option_selected[0].textContent).removeClass('hide');
    $(selectContainer).find('.defaultText').addClass('hide');
    const text = $(option_selected[0]).data('city') + " " + $(option_selected[0]).data('address');
    if (personal.length > 0) {
      personal.find('.custom-operator')[0].textContent = text;
      personal.removeClass('hide');
    }
    if ($('.tv-js-store-contact').closest('.tv-contactForm-radioContainer').find("input[type='radio']:checked")[0].value == 'schedule_appointment') {
      var disabled_date = $(option_selected[0]).data('disabled-dates')
      _datepicker(disabled_date);
    }
    if ($('.tv-js-store-contact').closest('.tv-contactForm-radioContainer').find("input[type='radio']:checked")[0].value != 'schedule_appointment') {
      $('#contact_date').addClass('hide');
      $('.tv-space-top').addClass('hide');
    }
  } else {
    $(selectContainer).find('.selectText').addClass('hide');
    $(selectContainer).find('.defaultText').removeClass('hide');
    if (personal.length > 0) {
      personal.find('.custom-operator')[0].textContent = '';
      $('.tv-js-personal').addClass('hide');
    }
  }
}

function customRadio(radio) {
  $('#contact_date').addClass('hide');
  $('.tv-space-top').addClass('hide');
  var option_selected = $(radio).closest('.tv-contactForm-radioContainer').find("input[type='radio']:checked"),
      parent =  $(radio).closest('form'),
      personal = $('.tv-js-personal');
  if(option_selected[0] && option_selected[0].value == 'question_product'){
    if ($(parent[0]).find('.tv-contactForm-selectContainer').length) {
      var placeholder = $(parent[0]).find('.tv-contactForm-selectContainer .placeholder-brand').text();
      $(parent[0]).find('.tv-contactForm-selectContainer .tv-contactForm-selectTxt .defaultText')[0].textContent = placeholder;
      $(parent[0]).find('.tv-contactForm-selectContainer select option[value]')[0].textContent = placeholder;
      $(parent[0]).find('.tv-contactForm-selectContainer').removeClass('hide');
    }
    if (!personal.text().includes("[name and address operator]")) {
      $('.tv-js-personal').removeClass('hide');
    }
  }
  else if((option_selected[0] && option_selected[0].value == 'contact_boutique') || (option_selected[0] && option_selected[0].value == 'schedule_appointment')) {
    if ($(parent[0]).find('.tv-contactForm-selectContainer').length) {
      var placeholder = $(parent[0]).find('.tv-contactForm-selectContainer .placeholder-store').text();
      $(parent[0]).find('.tv-contactForm-selectContainer .tv-contactForm-selectTxt .defaultText')[0].textContent = placeholder;
      $(parent[0]).find('.tv-contactForm-selectContainer select option[value]')[0].textContent = placeholder;
      $(parent[0]).find('.tv-contactForm-selectContainer').removeClass('hide');
    }

    if (!personal.text().includes("[name and address operator]")) {
      $('.tv-js-personal').removeClass('hide');
    }

    // Canada page, contact_store is hidden input, other form contact_store is select
    if (option_selected[0] && option_selected[0].value == 'schedule_appointment' && $('#contact_store[type="hidden"]').length) {
      var disabled_date = $('#contact_store').data('disabled-dates')
      _datepicker(disabled_date);
    }
  }
  else if (option_selected[0] == undefined) {
    $(parent[0]).find('.tv-contactForm-selectContainer').addClass('hide');
    $('.tv-js-contactForm-select').find('option.default-value').prop('selected', true);
    $('.tv-js-personal').addClass('hide');
  }
  else {
    $(parent[0]).find('.tv-contactForm-selectContainer').addClass('hide');
  }
}


/**
 *
 * disabled_date => lundi = 0, Mardi = 1 etc, dimache = 6
 * norme calendar informatique => dimanche = 0, samedi = 6
 */
function _datepicker(disabled_date) {
  $('#contact_date').flatpickr({
    "disable": [
      function(date) {
        result = false
        disabled_date.forEach(function(element) {
          if (element == 6) {
            result = date.getDay() === 0
          } else if (result === false) {
            result = date.getDay() === (element + 1)
          }
        });
        // return true to disable
        return result;
      }
    ],
    "locale": {
      "firstDayOfWeek": 1 // start week on Monday
    }
  })
  $('#contact_date').removeClass('hide');
  $('.tv-space-top').removeClass('hide');
}